import { SET_IS_NEW_RECORD } from '../actionTypes';
import { createContactModalActions } from '../reducer';

export default (value) => createContactModalActions[SET_IS_NEW_RECORD](value);
